export class connectVMModel {
  
    constructor(
      public mail: string,
      public passw: string,
      public order_id: string
      
    ) {  }
  
  }


// WEBPACK FOOTER //
// ./src/app/create-workspace/http-post-request-object-classes/connectVMModel.ts